import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchSamplePapers = createAsyncThunk(
  "samplePaper/fetchSamplePapers",
  async (_, thunkAPI) => {
    try {
      const response = await axios.post(
        `${server}/sample_paper_by_class`,
        {},
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );

      const responseData = response.data?.["body-json"]?.body?.data;

      if (Array.isArray(responseData)) {
        return responseData.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching sample paper:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const samplePaperSlice = createSlice({
  name: "samplePaper",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSamplePapers.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchSamplePapers.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchSamplePapers.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default samplePaperSlice.reducer;
